import { CONNECT_SUCCESS, SET_AGENT, BOT_BLINK, AGENT_BLINK } from '../actions';

const INIT_STATE = {
  newConnection: undefined,
  isAgent: undefined,
  botBlink: undefined,
  agentBlink: undefined,
};

export default (state = INIT_STATE, action) => {
  // console.log(action.type);
  // console.log(state);
  switch (action.type) {
    case CONNECT_SUCCESS:
      return {
        ...state,
        newConnection: action.payload,
        isAgent: true,
        botBlink: state.botBlink,
        agentBlink: state.agentBlink,
      };
    case SET_AGENT:
      return { ...state, isAgent: action.payload };
    case BOT_BLINK:
      return { ...state, botBlink: action.payload };
    case AGENT_BLINK:
      return { ...state, agentBlink: action.payload };
    default:
      return { ...state };
  }
};
